module.exports = __webpack_public_path__ + "img/ARY.c590988c.svg";